import cx from 'classnames';

import type { Publication } from '~/interfaces/publication';

interface LoadingPostProps {
  publication: Publication;
}

const LoadingPost = ({ publication }: LoadingPostProps) => {
  return (
    <div
      className={cx(
        'text-md cursor-point flex h-36 w-full animate-pulse items-center justify-center rounded-wt transition-all',
        publication.web_theme.content_theme === 'light' ? 'bg-slate-200 text-wt-primary hover:bg-slate-200' : '',
        publication.web_theme.content_theme === 'dark' ? 'bg-white/5 text-wt-text-on-background hover:bg-white/20' : '',
        publication.web_theme.content_theme === 'secondary'
          ? 'bg-white/5 text-wt-text-on-background hover:bg-white/20'
          : '',
      )}
    />
  );
};

const NewsFeedPostsLoader = ({ publication }: LoadingPostProps) => {
  return (
    <div className="mb-4 grid grid-cols-1 gap-0 pb-8 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3 lg:gap-8">
      <LoadingPost publication={publication} />
      <LoadingPost publication={publication} />
      <LoadingPost publication={publication} />
      <LoadingPost publication={publication} />
      <LoadingPost publication={publication} />
      <LoadingPost publication={publication} />
      <LoadingPost publication={publication} />
    </div>
  );
};

export default NewsFeedPostsLoader;
